import styled from "styled-components";
import Media from "../../../assets/styles/media";

export const PageHeaderText = styled.span`
  font-size: 40px;
  font-weight: bold;

  ${Media.Below.desktop`
    font-size: 25px;
  `}

  ${Media.Below.mobileLarge`
    text-align: center;
  `}
`;

export const AccessMessage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  > svg {
    width: 40px;
    height: 40px;
    stroke: red;
  }
`;
